(function () {
  var wrapper = document.querySelector('.jkl-mega-menu-mobile');
  if (!wrapper) return;

  var mainList = wrapper.querySelector('[data-menu-main]');

  /* --- Tabs --- */
  var tabButtons = wrapper.querySelectorAll('[data-tab-target]');
  var tabContents = wrapper.querySelectorAll('[data-tab-content]');

  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabKey = btn.getAttribute('data-tab-target');

      tabButtons.forEach(function (b) { b.classList.remove('is-active'); });
      tabContents.forEach(function (c) { c.classList.remove('is-active'); });

      btn.classList.add('is-active');
      var target = wrapper.querySelector('[data-tab-content="' + tabKey + '"]');
      if (target) target.classList.add('is-active');

      /* When switching back to menu tab, reset to L1 view */
      if (tabKey === 'menu') {
        showMainList();
      }
    });
  });

  function hideAllSubmenus() {
    wrapper.querySelectorAll('.jkl-mega-menu-mobile__submenu').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }

  function showPanel(submenuId) {
    hideAllSubmenus();
    mainList.classList.add('is-hidden');
    var target = wrapper.querySelector('[data-submenu-id="' + submenuId + '"]');
    if (target) target.classList.add('is-active');
  }

  function showMainList() {
    hideAllSubmenus();
    mainList.classList.remove('is-hidden');
    wrapper.querySelectorAll('[aria-expanded="true"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  /* Forward navigation: L1 → L2 or L3, L2 → L3 */
  wrapper.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-submenu-target]');
    if (trigger) {
      e.preventDefault();
      var targetId = trigger.getAttribute('data-submenu-target');
      trigger.setAttribute('aria-expanded', 'true');
      showPanel(targetId);
      return;
    }

    /* Back navigation */
    var backBtn = e.target.closest('[data-back-to]');
    if (backBtn) {
      e.preventDefault();
      var backTo = backBtn.getAttribute('data-back-to');

      if (backTo === '1') {
        showMainList();
      } else if (backTo === '2') {
        var parentId = backBtn.getAttribute('data-parent-submenu');
        hideAllSubmenus();
        var parentPanel = wrapper.querySelector('[data-submenu-id="' + parentId + '"]');
        if (parentPanel) parentPanel.classList.add('is-active');
      }
    }
  });
})();
